// extracted by mini-css-extract-plugin
export var copyableField = "_on-4";
export var customerBadge = "_on-0";
export var customerInfoTitle = "_on-2";
export var details = "_on-1";
export var dropdownContainer = "_on-5";
export var dropdownImage = "_on-6";
export var editAssigneeForm = "_on-a";
export var editButton = "_on-3";
export var email = "_on-7";
export var hidden = "_on-d";
export var input = "_on-8";
export var saveButton = "_on-b";
export var shopifyIcon = "_on-c";
export var suggestionBadge = "_on-e";
export var suggestionText = "_on-f";
export var username = "_on-9";